<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="-1" :multi-line="true" :bottom="true">
      <span
        >{{ $t('components.common.cookieSnackbarText') }}
        <a class="secondary--text" @click="showCookieInfo = true">{{ $t('components.common.whatIsCookies') }}</a></span
      >
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" class="black--text" v-bind="attrs" @click="closeSnackbar"> {{ $t('components.common.iUnderstand') }} </v-btn>
      </template>
    </v-snackbar>

    <cookie-info-component :visible="showCookieInfo" @close="showCookieInfo = false"></cookie-info-component>
  </div>
</template>

<script>
import CookieInfoComponent from '../dialog/CookieInfoComponent.vue';

export default {
  components: {
    CookieInfoComponent,
  },

  data() {
    return {
      snackbar: true,
      showCookieInfo: false,
    };
  },

  created() {
    if (localStorage.hideCookieInfo) {
      this.snackbar = false;
    }
  },

  methods: {
    closeSnackbar() {
      localStorage.hideCookieInfo = true;
      this.snackbar = false;
    },
  },
};
</script>
